import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_2 = { class: "w-1/3 p-6" }
const _hoisted_3 = { class: "border-b-4 border-grey-600 rounded-lg shadow-xl p-5" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = { class: "flex-1 text-right md:text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold uppercase text-gray-600" }, "店舗数", -1)
const _hoisted_7 = { class: "font-bold text-3xl" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-500" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-up" })
], -1)
const _hoisted_9 = { class: "w-1/3 p-6" }
const _hoisted_10 = { class: "border-b-4 border-grey-600 rounded-lg shadow-xl p-5" }
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = { class: "flex-1 text-right md:text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold uppercase text-gray-600" }, "スタッフ数", -1)
const _hoisted_14 = { class: "font-bold text-3xl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-500" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-up" })
], -1)
const _hoisted_16 = { class: "w-1/3 p-6" }
const _hoisted_17 = { class: "border-b-4 border-grey-600 rounded-lg shadow-xl p-5" }
const _hoisted_18 = { class: "flex flex-row items-center" }
const _hoisted_19 = { class: "flex-1 text-right md:text-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold uppercase text-gray-600" }, "お客様", -1)
const _hoisted_21 = { class: "font-bold text-3xl" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-500" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-up" })
], -1)
const _hoisted_23 = {
  key: 1,
  class: "flex flex-col mt-4 overflow-hidden"
}
const _hoisted_24 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_25 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_26 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_27 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_28 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_29 = { class: "px-6 py-4 text-gray-500 whitespace-nowrap" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$store.state.salon_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("h3", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.salon.shop_count || "0") + " ", 1),
                    _hoisted_8
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("h3", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.salon.staff_count || "0") + " ", 1),
                    _hoisted_15
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("h3", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_ctx.salon.user_count || "0") + " ", 1),
                    _hoisted_22
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.role == 'salon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  _createElementVNode("tbody", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (topic) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: topic.id
                      }, [
                        _createElementVNode("td", _hoisted_29, [
                          _createVNode(_component_router_link, {
                            to: `/topics/${topic.id}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(topic.created_at, "YYYY/MM/DD")), 1),
                              _hoisted_30,
                              _createTextVNode(" " + _toDisplayString(topic.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}